import { darkColors, lightColors } from '../../theme/colors'
import { ToggleTheme, variants } from './types'

const { DEFAULT, PANEL } = variants

export const light: ToggleTheme = {
  [DEFAULT]: {
    backgroundHandleActive: lightColors.gray10,
    backgroundHandleInactive: 'rgba(255, 255, 255, 0.2)',
    backgroundToggleActive: lightColors.purple,
    backgroundToggleInactive: lightColors.white,
    borderColorInactive: 'transparent',
    borderColorActive: 'transparent'
  },
  [PANEL]: {
    backgroundHandleActive: lightColors.purple,
    backgroundHandleInactive: lightColors.purpleHover,
    backgroundToggleActive: lightColors.purple,
    backgroundToggleInactive: 'transparent',
    borderColorInactive: 'rgba(255, 255, 255, 0.03)',
    borderColorActive: 'rgba(255, 255, 255, 0.03)'
  }
}

export const dark: ToggleTheme = {
  [DEFAULT]: {
    backgroundHandleActive: darkColors.white,
    backgroundHandleInactive: darkColors.gray6,
    backgroundToggleActive: darkColors.purple,
    backgroundToggleInactive: 'transparent',
    borderColorInactive: darkColors.gray8,
    borderColorActive: 'transparent'
  },
  [PANEL]: {
    backgroundHandleActive: darkColors.white,
    backgroundHandleInactive: darkColors.gray6,
    backgroundToggleActive: darkColors.purple,
    backgroundToggleInactive: 'transparent',
    borderColorInactive: darkColors.gray8,
    borderColorActive: 'transparent'
  }
}
